import type { ModuleEntitlement } from '@/api/merchant/workbench'

const K_MERCHANT_ID = 'b_merchant_id'
const K_MERCHANT_NAME = 'b_merchant_name'
const K_SHOP_NAME = 'b_shop_name'
const K_MODULES = 'b_module_entitlements'
const K_PERMISSIONS = 'b_permissions'
const K_MALL_BIZ_MODE = 'b_mall_biz_mode'

export interface MerchantSession {
  merchantId: string
  merchantName?: string
  /** 商城店铺名（侧栏优先展示） */
  shopName?: string
  modules: ModuleEntitlement[]
  permissions: string[]
  /** 商城经营模式；空表示未下发或读取失败，发票菜单不展示 */
  mallBizMode?: string
}

export function getMerchantSession(): MerchantSession | null {
  const merchantId = localStorage.getItem(K_MERCHANT_ID)
  if (!merchantId) return null
  const raw = localStorage.getItem(K_MODULES)
  let modules: ModuleEntitlement[] = []
  try {
    modules = raw ? JSON.parse(raw) : []
  } catch {
    modules = []
  }
  const permRaw = localStorage.getItem(K_PERMISSIONS)
  let permissions: string[] = []
  try {
    permissions = permRaw ? JSON.parse(permRaw) : []
  } catch {
    permissions = []
  }
  return {
    merchantId,
    merchantName: localStorage.getItem(K_MERCHANT_NAME) || undefined,
    shopName: localStorage.getItem(K_SHOP_NAME) || undefined,
    modules,
    permissions,
    mallBizMode: localStorage.getItem(K_MALL_BIZ_MODE) || undefined
  }
}

export function setMerchantSession(s: MerchantSession) {
  localStorage.setItem(K_MERCHANT_ID, s.merchantId)
  if (s.merchantName) localStorage.setItem(K_MERCHANT_NAME, s.merchantName)
  else localStorage.removeItem(K_MERCHANT_NAME)
  if (s.shopName) localStorage.setItem(K_SHOP_NAME, s.shopName)
  else localStorage.removeItem(K_SHOP_NAME)
  localStorage.setItem(K_MODULES, JSON.stringify(s.modules))
  localStorage.setItem(K_PERMISSIONS, JSON.stringify(s.permissions))
  if (s.mallBizMode) localStorage.setItem(K_MALL_BIZ_MODE, s.mallBizMode)
  else localStorage.removeItem(K_MALL_BIZ_MODE)
}

export function patchMerchantShopName(shopName: string) {
  const name = shopName?.trim()
  if (!name) return
  localStorage.setItem(K_SHOP_NAME, name)
  // 侧栏读 merchantName 兜底时也一并刷新，避免仍显示旧账号名
  localStorage.setItem(K_MERCHANT_NAME, name)
  window.dispatchEvent(new CustomEvent('merchant-shop-name-updated', { detail: { shopName: name } }))
}

export function clearMerchantSession() {
  localStorage.removeItem(K_MERCHANT_ID)
  localStorage.removeItem(K_MERCHANT_NAME)
  localStorage.removeItem(K_SHOP_NAME)
  localStorage.removeItem(K_MODULES)
  localStorage.removeItem(K_PERMISSIONS)
  localStorage.removeItem(K_MALL_BIZ_MODE)
}

export function getActiveModuleIds(): string[] {
  return getMerchantSession()?.modules.map((m) => m.moduleId) || []
}
